import { render, staticRenderFns } from "./scmaAreaSelector.vue?vue&type=template&id=45886641&scoped=true&"
import script from "./scmaAreaSelector.vue?vue&type=script&lang=js&"
export * from "./scmaAreaSelector.vue?vue&type=script&lang=js&"
import style0 from "./scmaAreaSelector.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./scmaAreaSelector.vue?vue&type=style&index=1&id=45886641&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45886641",
  null
  
)

export default component.exports